// https://github.com/jaubourg/ajaxHooks
if (window.XDomainRequest) {
    jQuery.ajaxTransport(function (s) {
        if (s.crossDomain && s.async) {
            if (s.timeout) {
                s.xdrTimeout = s.timeout;
                delete s.timeout;
            }
            var xdr_1;
            return {
                send: function (_, complete) {
                    function callback(status, statusText, responses, responseHeaders) {
                        xdr_1.onload = xdr_1.onerror = xdr_1.ontimeout = jQuery.noop;
                        xdr_1 = undefined;
                        complete(status, statusText, responses, responseHeaders);
                    }
                    xdr_1 = new XDomainRequest();
                    xdr_1.onload = function () {
                        callback(200, "OK", { text: xdr_1.responseText }, "Content-Type: " + xdr_1.contentType);
                    };
                    xdr_1.onerror = function () {
                        callback(404, "Not Found");
                    };
                    xdr_1.onprogress = function () {
                        window.console && window.console.log('progress');
                    };
                    xdr_1.ontimeout = function () {
                        callback(0, "timeout");
                    };
                    xdr_1.timeout = s.xdrTimeout || Number.MAX_VALUE;
                    xdr_1.open(s.type, s.url);
                    xdr_1.send((s.hasContent && s.data) || null);
                },
                abort: function () {
                    if (xdr_1) {
                        window.console && window.console.log('abort');
                        xdr_1.onerror = jQuery.noop;
                        xdr_1.abort();
                    }
                }
            };
        }
    });
}
//# sourceMappingURL=xdr.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/http/xdr.js
// module id = 50
// module chunks = 1